/* eslint-disable ember/no-computed-properties-in-native-classes */
import { QUESTION_TYPES } from 'client-portal/utils/prescreener/constants';
import { buildValidations, validator } from 'ember-cp-validations';
import { not, reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Model, { attr } from '@ember-data/model';

const Validations = buildValidations({
  value: [
    validator('inline', {
      validate(value, options, model) {
        const errorMessage = model.validationMessages?.required;
        if (!errorMessage) return true;

        if (model.questionType === QUESTION_TYPES.MULTISELECT) {
          return (Array.isArray(value) && value.length > 0) || errorMessage;
        }

        if (model.questionType === QUESTION_TYPES.FILE) {
          return model.customValidator(value, model) || errorMessage;
        }

        return (value && String(value).trim() !== '') || errorMessage;
      },
      disabled: not('model.required'),
    }),
    validator('length', {
      max: reads('model.maxLength'),
      disabled: not('model.maxLength'),
      message: reads('model.validationMessages.maxLength'),
    }),
  ],
});

/* eslint-enable ember/no-computed-properties-in-native-classes */

export default class PrescreenerAnswerValidationModel extends Model.extend(Validations) {
  @service prescreener;

  @attr('string') name;
  @attr('string') type;

  @attr('string') category;
  @attr('boolean') required;
  @attr('number') maxLength;

  @attr() value;
  @attr() validationMessages;
  @attr() customValidator;
}
